import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

type Props = {
  variant: 'error' | 'credits'
  /** The failure text for `error`, or an extra sentence appended to the credits copy. */
  message?: string
  onClose: () => void
}

export default function DialogMessage({ variant, message, onClose }: Props) {
  const isError = variant === 'error'

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-16 text-center">
      <ExclamationCircleIcon className={`mb-4 size-12 ${isError ? 'text-red-400' : 'text-amber-400'}`} />
      <p className="mb-2 text-base font-semibold text-gray-800">
        {isError ? 'Something went wrong' : 'Ad generation credits exhausted'}
      </p>
      <p className="max-w-sm text-sm text-gray-500">
        {isError
          ? message
          : `You've used all your ad generation credits for this billing period.${message ? ` ${message}` : ''}`}
      </p>
      <button
        type="button"
        onClick={onClose}
        className="mt-6 rounded-lg bg-gray-100 px-4 py-2 text-sm transition hover:bg-gray-200"
      >
        Close
      </button>
    </div>
  )
}
